/**
 * @param {string} date ISO 8601 format (e.g., 2023-02-01T00:00:00.000Z)
 * @returns {string} Formatted date (e.g., February 01, 2023)
 */
export default function formatLongDate(date, useUTC = true) {
  return new Date(Date.parse(date)).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    ...(useUTC ? { timeZone: 'UTC' } : {}),
  });
}
